module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAtCAYAAADV2ImkAAABN0lEQVR4Ae2VgUZEQRSGfxKACAhRT1EBFdAjVA9QgBAA1SME1FtUT1CAqDk7u0oQiu0ZsvA3cx0cq2avkr2zzsfPcOef811w8B8wgDmoBRd2YRd2YRd2YRd2YRd2YRd24b/DVyww4C5lpyTMZyxRcM+INUwTCo4aOcGnlbbCKvui924xbdjDuZW2wmOywicsItE5aapwQbZz0tR0U9ZKVyNrpauQtVBwrLIzg+M4DBilDFOuKdgjMY8fyN8YsEvBlXZGpn9DwX6rfppl+q3mW2GOZZiKp+xjgwMs5zRnwYk+zAn5YA9ntP2I9WK/MP/7vxassIdDBvQnPigYNHcjVnPX9A8YEH/VL8xvs7G2GHCR8pjylvLenAWXjNhusTw2tf9Q7hfm57s6H47jODOKbh5WEWKuOuEvY3QnOaqMe10AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/impact-resistance-icon.png
// module id = 289
// module chunks = 0